import _ from 'underscore';

import RESTUtils from '../../utils/rest-utils';
import { wait } from '../../utils/general-utils';
import { isDev } from '../../utils/general-utils';

export const DEFAULT_BACKGROUND_COLOR = isDev ? 'var(--app-bg-color-dev)' : 'var(--app-bg-color-prod)';

export function parseMemberData(memberData) {
    const name = memberData?.MemberInfo?.Name;
    const tierCode = memberData?.CardInfo?.TierCode;

    const cardInfo = memberData?.CardInfo;
    const membershipInfo = memberData?.MembershipInfo;

    const cardId = cardInfo?.CardNo;

    const rewardCycleLists = (cardInfo?.RewardCycleLists || []).filter(c => c?.PointsExpiringDate && ((new Date(c.PointsExpiringDate)).getTime() + 24 * 60 * 60 * 1000 > (new Date()).getTime()) && (c?.PointsBALValue || 0) >= 0).sort((x, y) => x.PointsExpiringDate < y.PointsExpiringDate ? -1 : 1);
    const currentCycleInfo = rewardCycleLists.filter(c => c.PointsType === 'Current')[0];
    const graceCyclesInfo = rewardCycleLists.filter(c => c.PointsType === 'Grace');
    const graceCycleInfo = graceCyclesInfo[0];

    const totalCycleSpending = membershipInfo?.TotalCycleSpending || 0;
    const superStarStatusExtended = totalCycleSpending >= 1000;
    const shortfallToExtendSuperStarStatus = superStarStatusExtended ? 0 : 1000 - totalCycleSpending;

    const pointsBAL = currentCycleInfo?.PointsBALValue || 0;

    return {
        name, tierCode, cardInfo, cardId, membershipInfo, currentCycleInfo, graceCyclesInfo, graceCycleInfo,
        totalCycleSpending, pointsBAL,
        superStarStatusExtended, shortfallToExtendSuperStarStatus
    };
}

export function clearMemberDataInLocalStorage() {
    localStorage.removeItem('secret');
    localStorage.removeItem('token');
    localStorage.removeItem('lastMemberRecord');
}

export function daysElapsedSince(dt) {
    return ((new Date()).getTime() - dt.getTime()) / (1000 * 60 * 60 * 24);
}

export function registerNewMember({
    token,
    cfmAcceptTnC, cfmInfoReal,
    name, dateOfBirth, mobileNumber, email,
    allowEmail = false, allowInstantMessengerServices = false, allowSMS = false,
    submissionLongitude = null, submissionLatitude = null
}) {
    // CAP-MEMBER-ONBOARDING: new registration request payload
    const payload = {
        token,
        cfmAcceptTnC, cfmInfoReal,
        name, dateOfBirth, mobileNumber, email,
        allowEmail, allowInstantMessengerServices, allowSMS,
        submissionLongitude, submissionLatitude
    };
    console.log(payload)
    return RESTUtils.call('/register-new-swensens-member', payload, { method: 'POST' })
}

export function registerChild({
    token,
    cfmAcceptTnC, cfmInfoReal,
    name, dateOfBirth, email,
    allowEmail = false, allowInstantMessengerServices = false, allowSMS = false
}) {
    const payload = {
        token,
        cfmAcceptTnC, cfmInfoReal,
        name, dateOfBirth, email,
        allowEmail, allowInstantMessengerServices, allowSMS
    };

    return RESTUtils.call('/register-child-for-swensens-member', payload, { method: 'POST' })
}

export function tryRecoverMembershipCardID({
    email,
}) {
    // CAP-MEMBER-ONBOARDING: membership-card recovery request payload
    const payload = { email };
    console.log(payload)
    return RESTUtils.call('/recovery-membership-card-id', payload, { method: 'POST' })
}

export function tryLinkMember({
    token, membershipCardID, dateOfBirth, mobileNumber, email,
}) {
    // CAP-MEMBER-ONBOARDING: existing-member link request payload
    const payload = {
        token, membershipCardID, dateOfBirth, mobileNumber, email,
    };
    console.log(payload)
    return RESTUtils.call('/try-link-swensens-member', payload, { method: 'POST' })
}

export function updateMemberProfile({
    token, newName, newMobileNo, newDOB
}) {
    // CAP-MEMBER-SELF-SERVICE: particulars-change request payload
    const payload = {
        token,
        name: newName, mobile: newMobileNo, dob: (new Date(newDOB)).getTime() - 60 * 60 * 1000 * 8
    };
    console.log(payload)
    return RESTUtils.call('/request-particulars-change', payload, { method: 'POST' })
}

export function clearVoucherDataInLocalStorage() {
    Object.keys(localStorage)
        .filter(k => k.startsWith('voucher:'))
        .forEach(k => localStorage.removeItem(k));
}

export function removeOldVoucherDataInLocalStorage() {
    Object.keys(localStorage)
        .filter(k => k.startsWith('voucher:'))
        .forEach(key => {
            try {
                const rawData = JSON.parse(localStorage.getItem(key) || '[]');
                const newData = rawData.filter(item => daysElapsedSince(new Date(item._ts)) <= 3);
                if (newData.length > 0) {
                    localStorage.setItem(key, JSON.stringify(newData));
                } else {
                    localStorage.removeItem(key)
                }
            } catch {
                localStorage.removeItem(key)
            }
        });
}

export function telegramQRScan(qrScanText = '') {
    // const qrScanSupported = window?.Telegram?.WebApp && window?.Telegram?.WebApp?.platform !== 'tdesktop' && window?.Telegram?.WebApp?.platform !== 'unknown' && (Number(window?.Telegram?.WebApp?.version) || 0) >= 6.4;
    const qrScanSupported = window?.Telegram?.WebApp && (
        window?.Telegram?.WebApp?.platform !== 'tdesktop'
    ) && (
        (
            window?.Telegram?.WebApp?.platform !== 'unknown' &&
            (Number(window?.Telegram?.WebApp?.version) || 0) >= 6.4
        ) || (
            typeof window?.Telegram?.WebApp?.showScanQrPopup === 'function' && typeof window?.Telegram?.WebApp?.closeScanQrPopup === 'function'
        )
    );
    if (!qrScanSupported && isDev) {
        console.log('Telegram QR Scan not supported: Returning default result in dev.')
        return Promise.resolve('https://lsc.abrholdings.ltd/r#90b4b9e0e8fb20273e3c526d92768ccbc5e3f800');
    } else {
        return new Promise((resolve, reject) => {
            if (qrScanSupported) {
                let resolved = false;
                window.Telegram.WebApp.showScanQrPopup({ text: qrScanText }, r => {
                    console.log('QR Scan Result:', r)
                    window.Telegram.WebApp.closeScanQrPopup()
                    resolved = true;
                    resolve(r)
                })
                setTimeout(() => {
                    if (!resolved) {
                        window.Telegram.WebApp.closeScanQrPopup()
                        reject('qr-scan-timed-out');
                    }
                }, 10000)
            } else {
                reject('qr-scan-not-supported');
            }
        });
    }
}

export function hexEncode(s, code_shift = 79, code_shift_rate = 19) {
	let result = '';
	for (let i = 0; i < s.length; i++) {
		const hex = ((s.charCodeAt(i) + code_shift + i * code_shift_rate) % 256).toString(16);
		result += ('000' + hex).slice(-2);
	}
	return result
}

export function hexDecode(s, code_shift = 79, code_shift_rate = 19) {
	const hexes = s.match(/.{1,2}/g) || [];
	let result = '';
	for (let j = 0; j < hexes.length; j++) {
		result += String.fromCharCode((parseInt(hexes[j], 16) + (256 - j) * code_shift_rate - code_shift) % 256);
	}
	return result;
}

export function decodeTableInfoHash(hash = '') {
    const encodedTableInfo = hash.startsWith('#') ? hash.slice(1) : hash;
    if (!/^(?:[0-9a-f]{2})+$/i.test(encodedTableInfo)) {
        throw new Error('invalid-qr-data');
    }
    const tableInfoParts = hexDecode(encodedTableInfo, 79, 19).split('_');
    if (tableInfoParts.length !== 4) {
        throw new Error('invalid-qr-data');
    }
    return {
        outlet: tableInfoParts[1],
        table: tableInfoParts[2],
    };
}

export function qrScanForTableInfo() {
    return telegramQRScan('Swensen\'s Table Standee')
        .then(r => {
            if (!r.startsWith('https://lsc.abrholdings.ltd/r#')) {
                return Promise.reject('invalid-qr-data');
            }
            let result;
            try {
                result = decodeTableInfoHash(r.split('#')[1]);
            } catch {
                // Preserve the scanner's existing string rejection reason.
                return Promise.reject('invalid-qr-data');
            }
            console.log('QR Scan Table Result:', result);
            return result;
        });
}

export function telegramHapticFeedback(feedbackType = 'success') {
    if (window?.Telegram?.WebApp?.HapticFeedback && (Number(window?.Telegram?.WebApp?.version) || 0) >= 6.1) {
        if (feedbackType !== 'success' || feedbackType !== 'warning' || feedbackType !== 'error') {
            window.Telegram.WebApp.HapticFeedback.notificationOccurred(feedbackType)
        }
    }
}

export function extractRecentVoucherRedemptionsFromMemberData(memberData) {
    // const groups = _.groupBy((memberData?.__addenda__ || []).filter(({ key }) => key.startsWith('voucher-redemption:')), ({ data: { Voucher: { vid, VoucherNo } } }) => vid || VoucherNo);
    // return Object.keys(groups)
    //     .map(voucherNumber => {
    //         const item = groups[voucherNumber].sort(({ ts: ts1 }, { ts: ts2 }) => ts1 < ts2 ? 1 : -1)[0];
    //         const result = {
    //             voucherNumber,
    //             _ts: new Date(item.ts).getTime(),
    //             ts: new Date(item.ts),
    //             cardNumber: memberData.CardInfo.CardNo,
    //             data: {
    //                 transactionReferenceInfo: item.data.TransactionReferenceInfo,
    //                 voucherData: item.data.Voucher,
    //                 voucherType: item.data.VoucherType,
    //             }
    //         };
    //         return result;
    //     })

    const allRedemptions = (memberData?.__addenda__ || []).filter(({ key }) => key && key.startsWith('voucher-redemption:')).sort(({ ts: ts1 }, { ts: ts2 }) => ts1 < ts2 ? 1 : -1);
    return allRedemptions.map(item => {
        const result = {
            voucherNumber: item?.data?.Voucher?.vid || item?.data?.Voucher?.VoucherNo,
            _ts: new Date(item.ts).getTime(),
            ts: new Date(item.ts),
            cardNumber: memberData.CardInfo.CardNo,
            data: {
                transactionReferenceInfo: item.data.TransactionReferenceInfo,
                voucherData: item.data.Voucher,
                voucherType: item.data.VoucherType,
                additionalRedemptionInformation: item.data?.additional_redemption_information || null,
                customRedemptionSource: item.data?.custom_redemption_source || null,
            }
        };
        return result;
    })
}

export function testAdditionalVoucherPrerequisites({ token, vid, childCardNumber, additionalRedemptionInformation }) {
    const payload = {
        VoucherNo: vid,
        VoucherType: 'additional',
        token,
        additionalRedemptionInformation,
    };
    if (childCardNumber) {
        payload.child_card_number = childCardNumber;
    }
    return RESTUtils.call('/test-voucher-redemption-requirements', payload, { method: 'POST' })
    // return new Promise(resolve => {
    //     // setTimeout(() => resolve({ data: { success: true }}), 2000);
    //     setTimeout(() => resolve({ data: { success: false }}), 2000);
    // })
}

export function redeemVoucher({ token, voucherNumber, voucherType, childCardNumber, additionalRedemptionInformation, customRedemptionSource }) {
    const payload = {
        token,
        VoucherNo: voucherNumber, VoucherType: voucherType,
        additionalRedemptionInformation,
        customRedemptionSource,
    };
    if (childCardNumber) {
        payload.child_card_number = childCardNumber;
    }
    return RESTUtils.call('/request-voucher-redemption', payload, { method: 'POST' })
}

export function getMemberDataWithToken(token, setMemberData = () => null) {
    // CAP-MEMBER-SELF-SERVICE: assembled member-data retrieval path
    const waitForAtLeastASecond = wait(1000);
    return RESTUtils.call('/retrieve-member-data', { token }, { method: 'POST' })
        .then(({ data: memberData }) => {
            memberData.__addenda__.forEach(item => {
                try {
                    item.ts = new Date(item.ts * 1000)
                    item.ttl = item.ttl && new Date(item.ttl * 1000)
                    item.data = JSON.parse(item.data)
                } catch {
                    item._data = item.data
                    delete item.data;
                }
            })

            // Voucher List Modification
            memberData.VoucherLists = memberData.VoucherLists.filter(v => {
                // Remove FreeDDrink starting from 2023-08-01
                if (v.VoucherTypeCode === 'FreeDDrink' && (new Date() > new Date(2023, 8-1, 1))) {
                    return false;
                }
                return true;
            })

            Object.values(memberData['[Relationships]'].children).forEach(child => {
                child.Item.__addenda__.forEach(item => {
                    try {
                        item.ts = new Date(item.ts * 1000)
                        item.ttl = item.ttl && new Date(item.ttl * 1000)
                        item.data = JSON.parse(item.data)
                    } catch {
                        item._data = item.data
                        delete item.data;
                    }
                })
            })

            return waitForAtLeastASecond.then(() => {
                localStorage.setItem('token', token);
                localStorage.setItem('lastMemberRecord', JSON.stringify(memberData));
                setMemberData(memberData);
                return memberData;
            });
        });
}

export function setCommunicationsOptions({ token, allowInstantMessengerServices = false, allowEmail = false, allowSMS = false }) {
    // CAP-MEMBER-SELF-SERVICE: communication-preferences update payload
    const payload = { token, allowInstantMessengerServices, allowEmail, allowSMS };
    return RESTUtils.call('/update-member-communications-preferences', payload, { method: 'POST' })
}

export function HorizontallyCenteringContainer({ padding = '0px', additionalStyles = {}, children }) {
    return (padding !== '0px' || Object.keys(additionalStyles).length > 0) ? (
        <div className='flex-justify-center' style={_.extend({ padding }, additionalStyles)}>
            {children}
        </div>
    ) : (
        <div className='flex-justify-center'>
            {children}
        </div>
    )
}

export function VerticalSeparator({ height = '1em' }) {
    return (
        <div style={{ height }}></div>
    )
}

export function HorizontalSeparator({ width = '1em' }) {
    return (
        <div style={{ width }}></div>
    )
}

export function parseDateTimestampString(s, hourShift = 12) {
    const re = new RegExp('^\\/Date\\(([-]{0,1}[0-9]+)\\)\\/$')
    const m = s.match(re)
    return m && new Date(Number(m[1]) + hourShift * 60 * 60 * 1000)
}

if (isDev) {
    window._app__utils = {
        parseMemberData, clearMemberDataInLocalStorage, daysElapsedSince, registerNewMember, registerChild, tryRecoverMembershipCardID, tryLinkMember, updateMemberProfile, clearVoucherDataInLocalStorage, removeOldVoucherDataInLocalStorage,
        telegramQRScan, hexEncode, hexDecode, decodeTableInfoHash, qrScanForTableInfo,
        extractRecentVoucherRedemptionsFromMemberData, redeemVoucher, getMemberDataWithToken, setCommunicationsOptions,
        parseDateTimestampString,
    }
}

// const exampleData = {
//     "CardInfo": {
//         "CardNo": "82089151",
//         "MemberID": "4dx1wm489075",
//         "PrintedName": "Jeremy Chen",
//         "MembershipTypeCode": "Cool Rewards",
//         "MembershipStatusCode": "ACTIVE",
//         "MembershipPhoto": "",
//         "MembershipPhotoLink": "",
//         "IssueDate": "/Date(1553616000000)/",
//         "EffectiveDate": "/Date(1648310400000)/",
//         "ExpiryDate": "/Date(1679760000000)/",
//         "Printed": false,
//         "PrintedDate": null,
//         "RenewedDate": "/Date(1648310400000)/",
//         "tmpEffectiveDate": null,
//         "tmpExpiryDate": null,
//         "tmpMembershipStatusCode": "",
//         "PointsBAL": 0,
//         "TotalPointsBAL": 0,
//         "HoldingPoints": 0,
//         "Remarks": "",
//         "MembershipDiscount": 0,
//         "TierCode": "CR Member",
//         "SuppCardTierCode": "",
//         "TierAnniversaryStartDate": null,
//         "TierAnniversaryEndDate": null,
//         "LoyaltyMessage": "",
//         "DollarToPointsRatio": "",
//         "RewardCycleLists": [
//             {
//                 "PointsType": "Current",
//                 "PointsBALValue": 0,
//                 "PointsExpiringDate": "2023-06-26T00:00:00",
//                 "CycEndDate": "2023-03-26T00:00:00"
//             }
//         ],
//         "IsSupplementary": false,
//         "isBurnSupplementaryCard": false,
//         "RelationID": "7B05EA74-3637-4D1C-BE61-7FC4A5CD695A",
//         "PrimaryCardNo": "",
//         "PrimaryRelationID": "",
//         "PrimaryCardExpiryDate": null,
//         "PrimaryCardEffectiveDate": null,
//         "PtsHoldingDays": 0,
//         "MembershipTypeCCNFeatures": false,
//         "MembershipTypeDefaultCCNValue": "",
//         "MembershipTypeTierDefaultCCNValue": "",
//         "CurrentNetSpent": 0,
//         "Passcode": "          ",
//         "StoredValueBalance": 0,
//         "Currency": "SGD",
//         "LastVisitedDate": "/Date(1648310400000)/",
//         "LastVisitedOutlet": "",
//         "PointsToNextTier": "0",
//         "NettToNextTier": "0",
//         "LuckyDrawConversionPtsUsageType": "CURRENT",
//         "LuckyDrawConversionRate": "",
//         "DiscGroupCode": "",
//         "SpentQuotaIncreasementExpiredOn": null,
//         "SpentQuotaIncreasement": 0,
//         "DiscountGroupInfo": null,
//         "PickupDate": "/Date(1553687449977)/",
//         "PickupBy": "",
//         "CurrentRCNettSpent": 0,
//         "CVCInfo": {
//             "CNO": "",
//             "CCN": "",
//             "CVC": ""
//         },
//         "CMCEarnedPoints": 0,
//         "CRCEarnedPoints": 0,
//         "CurrentTierNett": 0,
//         "CurrentTierAmt": 0,
//         "BringFwdTierNett": 0,
//         "BringFwdTierAmt": 0,
//         "BringFwdTierExpiry": null,
//         "BringFwdTierStartDate": null,
//         "ExtendedTierAnniversaryEndDate": null
//     },
//     "MemberInfo": {
//         "MemberAutoID": "489075",
//         "MemberID": "4dx1wm489075",
//         "Salutation": "",
//         "Name": "Jeremy Chen",
//         "NRIC": "convexset@gmail.com",
//         "Passport": "",
//         "Email": "convexset@gmail.com",
//         "Gender": "",
//         "DOB": null,
//         "Nationality": "",
//         "Block": "",
//         "Level": "",
//         "Unit": "",
//         "Street": "",
//         "Building": "",
//         "PostalCode": "",
//         "Country": "",
//         "Address1": " ",
//         "Address2": "   ",
//         "Address3": "",
//         "ContactNo": "",
//         "MobileNo": "",
//         "FaxNo": "",
//         "ReferrerCode": "",
//         "FacebookID": "10157014609046335",
//         "FacebookName": "Jeremy Chen",
//         "FacebookPhotoLink": "",
//         "FacebookToken": "EAAFPFQkA7DoBAE8xdDVmc1aGMGLil9fZAZC9cPubOX8ohp8EaVy4RZClZAjQsQ4aZCQpjG3AQQaP2ZAhPVG4bTMdIx9iipAuMf1",
//         "FacebookTokenExpiry": "1617653280672.05",
//         "FullPhotoName": "",
//         "Base64PhotoString": "",
//         "PhotoLink": "",
//         "InterestGroupLists": null,
//         "MailingLists": [
//             {
//                 "Name": "Swensen's Cool Rewards"
//             }
//         ],
//         "DynamicColumnLists": null,
//         "DynamicFieldLists": null,
//         "JoinDate": "/Date(1553687449000)/",
//         "LastLoginDateTime": null,
//         "FirstLoginDateTime": null,
//         "ActiveTagList": [],
//         "IU": ""
//     },
//     "SupplementaryMember": null,
//     "MembershipInfo": {
//         "TotalSpending": 40.66,
//         "TotalPoints": 1.2,
//         "TotalVisits": 1,
//         "LastVisitedOutletCode": "",
//         "MostCycleVisitedOutletCode": "",
//         "TotalCycleVisits": 0,
//         "TotalCycleSpending": 0,
//         "TotalCyclePoints": 0,
//         "TotalBalPoints": 0,
//         "CurrentMonthSpending": 0,
//         "CurrentMonth_1Spending": 0,
//         "CurrentMonth_2Spending": 0,
//         "TotalNettSpending": 40.66,
//         "TotalCycleNettSpending": 0,
//         "CurrentMonthNettSpending": 0,
//         "CurrentMonth_1NettSpending": 0,
//         "CurrentMonth_2NettSpending": 0
//     },
//     "TotalActiveVoucherCount": 1,
//     "VoucherLists": [
//         {
//             "VoucherNo": "FreeDDrink_12674451359186",
//             "VoucherTypeCode": "FreeDDrink",
//             "VoucherTypeName": "[MOBILE] Free Daily Drink or 1 Beverage Upgrade",
//             "VoucherTypeDescription": "[MOBILE] Free Daily Drink or $1 Beverage Upgrade",
//             "Type": "MFreeItem",
//             "TypeValue": "",
//             "RefundValue": "",
//             "ValidFrom": "/Date(1530374400000)/",
//             "ValidTo": "/Date(4102329600000)/",
//             "ValidTimeFrom": "",
//             "ValidTimeTo": "",
//             "ValidTimeFrom_Sec": "",
//             "ValidTimeTo_Sec": "",
//             "IsRedeemable": true,
//             "VoucherRedemptionValue": 0,
//             "VoucherUsedOn": null,
//             "IsMinSpendingReq": false,
//             "MinSpendingValue": 0,
//             "Remarks": "- Redemption is valid with dine-in food order (incl. sundaes but excl. beverage, toppings and add-ons).\r\n- Choose either a free drink (coffee, tea or soft drink) or pay $1 to upgrade to a beverage of your choice.\r\n- Choice of $1 beverage excludes Iced Fruit Blended, Ice Cream Meltdowns and Yogen Fruz categories.\r\n- At Earle Swensen's outlets, choice of free drink is from Americano, Tea (Dilmah) or soft drink. Choice of $1 upgrade applies to illy coffee and GRYPHON tea range only.\r\n- Limited to 1 redemption per day per Member.\r\n\r\nPlease present this eVoucher to the server who is taking your order for redemption. Screenshots are not accepted. eVouchers redeemed are not reversible or refundable. The management reserves the right to amend this offer without prior notice.",
//             "EntityCode": "Swensens",
//             "TenderMode": "",
//             "VoucherIssuedOn": "/Date(1553687450480)/",
//             "IssuedOutletCode": "",
//             "IssuedOutletName": "",
//             "RedeemedOutletCode": "",
//             "RedeemedOutletName": "",
//             "Ref1": "VoucherTypeRef1|-| ",
//             "Ref2": "VoucherTypeRef2|-|All Swensen's and Earle Swensen's outlets in Singapore",
//             "Ref3": "VoucherTypeRef3|-|[MOBILE] Free Daily Drink or $1 Beverage Upgrade",
//             "Ref4": "VoucherTypeRef4|-| ",
//             "Ref5": "VoucherTypeRef5|-| ",
//             "Ref6": "VoucherTypeRef6|-| ",
//             "Ref7": "VoucherTypeRef7|-|https://uatcrm.ascentis.com.sg/MatrixResources/VoucherTypeImage/swensens/FreeDDrink.jpg",
//             "ActiveDaysOfWeek": "1111111",
//             "TaggingRef1": "",
//             "TaggingRef2": "",
//             "TaggingRef3": "",
//             "TaggingRef4": "",
//             "TaggingRef5": "",
//             "TaggingRef6": "",
//             "TaggingRef7": "",
//             "EligibleFlag": null,
//             "VouRemarks": "",
//             "VoucherUrl": "",
//             "ExpiryExtensionReason": ""
//         }
//     ],
//     "TotalSummaryVoucherCount": 0,
//     "VoucherSummary": null,
//     "JournalLists": null,
//     "ReceiptMessage": "                                        ",
//     "ReceiptImage": null,
//     "VoucherCapSettingList": null,
//     "CarParkRebateV1_BalanceInfoList": null,
//     "voucherSummaryReceipt": null,
//     "ReturnStatus": 1,
//     "ReturnMessage": "SUCCESS",
//     "RequestTime": "20221116225843",
//     "ResponseTime": "20221116225843"
// }
// exampleData.___ = null;
